import styled from 'styled-components';
import { Row } from 'reactstrap';
import { mediaBreakpointUp, getThemeProp, spacer, multiply } from '@whitelabel/helpers/style';

const boxMDUpHeight = '7.75rem';
const StyledRow = styled(Row)`
  > .column {
    > .column-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
      padding: 1rem;
      text-align: center;
      border: ${getThemeProp('borderStyle')};
      > .h5 {
        text-align: center;
        text-transform: unset;
      }
      ${mediaBreakpointUp('md')`
          margin-bottom: 0;
          height: ${boxMDUpHeight};
          > .h5 {
            margin-bottom: ${spacer};
          }
      `}
    }

    > .btn.btn-secondary {
      width: 100%;
      ${mediaBreakpointUp('sm')`
        justify-content: center;
      `}
      ${mediaBreakpointUp('md')`
          padding: 1rem;
          height: ${boxMDUpHeight};
          .svg-icon {
            margin-bottom: ${multiply(spacer, 0.5)};
          }
          > div > h3 {
            margin-bottom: ${multiply(spacer, 0.25)};
          }

          > .h5 {
            margin-bottom: ${spacer};
          }
      `}
    }
  }
`;

export { StyledRow };
